import { render } from "./TaskAssessmentModal.vue?vue&type=template&id=d8f9ad72&scoped=true"
import script from "./TaskAssessmentModal.vue?vue&type=script&lang=js"
export * from "./TaskAssessmentModal.vue?vue&type=script&lang=js"

import "./TaskAssessmentModal.vue?vue&type=style&index=0&id=d8f9ad72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8f9ad72"]])

export default __exports__